var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSplit = function SvgSplit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.449 3.448l-2.624 4.53.45.778-1.046.604-.8-1.381 3.323-5.74h6.645l.793 1.37-1.046.604-.443-.765H5.448zm-1.913 8.17l1.046-.604.867 1.495H10.7l2.623-4.53-.873-1.508 1.046-.604 1.223 2.112-3.323 5.739H4.752l-1.216-2.1zm8.995-7.435l1.109-.64.64 1.108-1.109.64-.64-1.108zm-1.106.638l-1.108.64.64 1.109 1.108-.64-.64-1.109zM8.102 6.74l1.109-.64.64 1.109-1.109.64-.64-1.109zm-1.105.639l-1.109.64.64 1.108 1.109-.64-.64-1.108zM3.674 9.296l1.109-.64.64 1.109-1.109.64-.64-1.109zM1.46 10.575l1.108-.64.64 1.108-1.108.64-.64-1.108z",
    fill: "#666"
  })));
};
export default SvgSplit;